import { app } from '../app.module'
app.controller('SettingCtrl', function ($scope, DialogService, UserService, RestangularService) {
  // ユーザが無い場合
  if ($scope.userId === undefined) {
    // ダッシュボードにリダイレクト
    location.href = '/main.html'
  }

  // 表示用にユーザデータをセット
  function setUserData() {
    // 表示状態にする
    $scope.isEdit = false
    // 保存フラグ
    $scope.saveFlag = true

    // 対象ユーザを取得
    UserService.User.getUser($scope.userId).then((userInfo) => {
      // ユーザが存在する場合
      if (userInfo !== null) {
        $scope.username = userInfo.username
        $scope.email = userInfo.email
        $scope.password = ''
        $scope.picture = userInfo.picture
        $scope.company = userInfo.company
        $scope.telephone = userInfo.telephone
      }
    })
  }

  setUserData()

  // 編集状態に変更
  $scope.changeEdit = function () {
    $scope.isEdit = true
  }

  // 編集フォームのvalidateをチェック
  $scope.$watch(
    function () {
      return $scope.userSettingForm.$invalid
    },
    function () {
      // フォームのvalidateの値
      if ($scope.userSettingForm.$invalid === true) {
        // 保存フラグをfalseにする
        $scope.saveFlag = false
      } else {
        // 保存フラグをtrueにする
        $scope.saveFlag = true
      }
    }
  )

  // 初期状態に変更
  $scope.changeDefault = function () {
    // 表示用にユーザデータをセット
    setUserData()
  }

  // 保存処理
  $scope.saveUserData = function () {
    // ユーザ情報をセット
    const userInfo = {
      userId: $scope.userId,
      username: $scope.username,
      email: $scope.email,
      password: $scope.password,
      picture: $scope.picture,
      company: $scope.company,
      telephone: $scope.telephone,
      groupId: $scope.groupId,
    }

    const getEndpoint = `/users/userByMail?userId=${$scope.userId}&email=${encodeURIComponent(
      $scope.email
    )}`

    RestangularService.request('GET', getEndpoint, null).then((result) => {
      // 既に登録済のメールアドレスではない場合、更新処理をスキップ
      if (result[0].data.length === 0) {
        const editEndpoint = '/users/user'

        RestangularService.request('UPDATE', editEndpoint, userInfo)
          .then(() => {
            // エラーが無い場合
            DialogService.showToast('保存しました。', 'success-toast')
            // 表示に戻る
            $scope.isEdit = false
            $scope.$emit('changeUserInfo', {
              data: userInfo,
            })
          })
          .catch(() => {
            // 保存失敗時
            DialogService.showToast('保存に失敗しました。', 'error-toast')
          })
      } else {
        // 既に登録済のメールアドレスの場合、アラートを表示
        DialogService.showToast('既に登録済のメールアドレスです。', 'error-toast')
      }
    })
  }
})
